module.exports = __webpack_public_path__ + "static/media/screen-3.b9cf6a56.png";